import {
  Box,
  Button,
  Card,
  Chip,
  Divider,
  Grid,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  ContentLayout,
  CustomDetailsList,
  EndofDayTableSimple,
  HeaderBreadcrumbs,
  Loader,
  TabPanel,
  useFormatAmount,
} from "../../../shared";
import { useEndofDay } from "../hooks";
import { EndofDayHistory } from "./EndofDayHistory";
import { TabContextProvider } from "../../../store";

export const EndofDayDetails = () => {
  const { id } = useParams();
  const formatAmount = useFormatAmount();
 
  const navigate = useNavigate();
  const {
    state,
    isSummaryVisble,
    isEditable,
    Cashtotal,
    isForceEdit,
    setState,
    onUpdateEndofDay,
  } = useEndofDay({
    isEndofDay: false,
    EndofdayId: id,
    isStore: false,
    isDetail: true,
  });

  const { pathname, search } = useLocation();
  const isStoreAdmin = pathname.includes("store-admin");

  const handleChange = (event, newValue) => {
    navigate({
      pathname: isStoreAdmin ? "/store-admin/end-of-day/details/" + id : "/end-of-day/details/" + id,
      search: newValue,
    });
  };

  const isEdit = isSummaryVisble
    ? state.is72HourPassed
      ? isForceEdit
        ? true
        : false
      : true
    : false;
  const isEdit2 = isEditable
    ? state.is72HourPassed
      ? isForceEdit
        ? true
        : false
      : true
    : false;

  const columns = [
    {
      title: "Staff Name",
      accessor: "user_name",
    },
    {
      title: "Terminal Name",
      accessor: "terminal_name",
    },
    {
      title: "Store",
      accessor: "store_name",
    },
    {
      title: "Sale Date",
      accessor: "sale_date",
    },
    {
      title: "Updated Date",
      accessor: "formatted_updated_at",
    },
    {
      title: "Status",
      accessor: (val) => {
        return (
          <Stack direction="row" spacing={2}>
            <Chip
              label={val.status === 0 ? "Pending" : "Approved"}
              color={val.status === 1 ? "success" : "warning"}
              variant={"outlined"}
              sx={{ bgcolor: "#FFF4CE", mt: 1 }}
              size="small"
            />
            {state.data.status === 0 && isSummaryVisble && (
              <Button
                type="button"
                size="medium"
                variant="contained"
                onClick={() => onUpdateEndofDay(id)}
              >
                End the Day
              </Button>
            )}
          </Stack>
        );
      },
    },
  ];
  const column = [
    {
      title: "Float Amount",
      accessor: "float_total",
        accessor: (row) => {
          return <div>{formatAmount(row.float_total)}</div>;
      },
      hidden: (row) => {
        return row.cashless_till ? true : false;
      },
    },
    {
      title: "Cheque",
      accessor: "cheque_total",
        accessor: (row) => {
          return <div>{formatAmount(row.cheque_total)}</div>;
      },
    },
    {
      title: "Remarks",
      backgroundColor: "#FFF4CE",
      hidden: (row) => {
        return row.remarks === null;
      },
      accessor: (row) => {
        return (
          <Typography color="#C07302" fontWeight={400} fontSize={16}>
            {row.remarks}
          </Typography>
        );
      },
    },
  ];

  const isTerminal = state.data.terminal_id !== null;

  return (
    <>
      {state.isBusy ? (
        <Loader />
      ) : (
        <ContentLayout
          title={state.data.store_name + "-" + state.data.terminal_name}
          breadcrumbs={
            <>
              <HeaderBreadcrumbs
                links={[
                  {
                    name: "Dashboard",
                    href: isStoreAdmin ? "/store-admin" : "/",
                  },
                  {
                    name: "End of Day",
                    href: isStoreAdmin
                      ? "/store-admin/end-of-day"
                      : "/end-of-day",
                  },
                  { name: "details" },
                ]}
              />
            </>
          }
        >
          <Box
            className="sticky-Tab "
            sx={{ borderBottom: 1, borderColor: "divider", top: "64px" }}
          >
            <Tabs value={search} onChange={handleChange}>
              <Tab label="Details" value="" />
              <Tab label="History" value="?history" />
            </Tabs>
          </Box>
          <TabContextProvider value={search}>
            <TabPanel sx={{ px: "0" }} value="">
              <>
                <CustomDetailsList
                  columns={columns}
                  data={state?.data}
                  title="Basic Details"
                />
                {isTerminal && (
                  <Card>
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      height="83px"
                      p="32px 24px"
                    >
                      <Typography variant="subtitle1" fontWeight={600}>
                        End of Day
                      </Typography>
                      {isEdit ? (
                        <>
                          <Button
                            size="medium"
                            variant="contained"
                            onClick={() =>
                              isStoreAdmin
                                ? navigate(`/store-admin/end-of-day/edit/${id}`)
                                : navigate(`/end-of-day/edit/${id}`)
                            }
                          >
                            Edit
                          </Button>
                        </>
                      ) : (
                        <>
                          {isEdit2 && state.data.status === 0 ? (
                            <Button
                              size="medium"
                              variant="contained"
                              onClick={() =>
                                isStoreAdmin
                                  ? navigate(
                                      `/store-admin/end-of-day/edit/${id}`,
                                    )
                                  : navigate(`/end-of-day/edit/${id}`)
                              }
                            >
                              Edit
                            </Button>
                          ) : (
                            ""
                          )}
                        </>
                      )}
                    </Stack>
                    <Divider />
                    <CustomDetailsList
                      columns={column}
                      data={state.data}
                      marginBottom={0}
                    />
                    {!state.data.cashless_till && (
                      <EndofDayTableSimple
                        denominations={state.data.denominations}
                        float_amount={state.data.float_total}
                        setState={setState}
                        stateKey="data"
                        disableTable={true}
                        cash_banked_total={state.data?.cash_banked_total || 0}
                        isDetails={true}
                      />
                    )}

                    <Divider />
                    {!isSummaryVisble && (
                      <Grid
                        container
                        sx={{
                          p: "29px 24px",
                          backgroundColor: "#E1FBF2",
                        }}
                      >
                        <Grid item md={4}>
                          <Typography
                            variant="subtitle1"
                            fontWeight={600}
                            color="#0F875B"
                          >
                            Total Amount
                          </Typography>
                        </Grid>
                        <Grid item md={8}>
                          <Typography
                            fontWeight={600}
                            fontSize={24}
                            color="#0F875B"
                            >
                              {formatAmount(Cashtotal + +state.data.cheque_total)}
                          </Typography>
                        </Grid>
                      </Grid>
                    )}
                  </Card>
                )}
                <Box marginTop={2} marginBottom={5}>
                  {isSummaryVisble && (
                    <Card>
                      <Grid
                        container
                        sx={{
                          height: "83px",
                          padding: "32px 24px",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Grid item>
                          <Typography
                            variant="h5"
                            fontSize={16}
                            sx={{
                              lineHeight: "19px",
                            }}
                          >
                            Summary
                          </Typography>
                        </Grid>
                      </Grid>
                      <Divider />
                      <Stack direction="row">
                        <Stack
                          border={1}
                          borderColor="#E6E6E6"
                          width="100%"
                          height="48px"
                          sx={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "14.5px 26px",
                          }}
                        >
                          <Typography>Cash in Hand</Typography>
                          <Typography>
                            {formatAmount(
                              Cashtotal ?? state.endofdaySummary.cash_total,
                            )}
                          </Typography>
                        </Stack>
                        <Stack
                          border={1}
                          borderColor="#E6E6E6"
                          width="100%"
                          height="48px"
                          sx={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "14.5px 26px",
                          }}
                        >
                          <Typography>Loyalty</Typography>

                          <Typography>
                            <Typography>
                              {formatAmount(state?.endofdaySummary?.loyalty_total)}
                            </Typography>
                          </Typography>
                        </Stack>
                      </Stack>
                      <Stack direction="row">
                        <Stack
                          border={1}
                          borderColor="#E6E6E6"
                          width="100%"
                          height="48px"
                          sx={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "14.5px 26px",
                          }}
                        >
                          <Typography>System Cash</Typography>
                          <Typography>
                            {formatAmount(state.endofdaySummary.system_cash)}
                          </Typography>
                        </Stack>
                        <Stack
                          border={1}
                          borderColor="#E6E6E6"
                          width="100%"
                          height="48px"
                          sx={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "14.5px 26px",
                          }}
                        >
                          <Typography>Gift Card</Typography>
                          <Typography>
                            {formatAmount(state?.endofdaySummary?.gift_card_total)}
                          </Typography>
                        </Stack>
                      </Stack>
                      <Stack direction="row">
                        <Stack
                          border={1}
                          borderColor="#E6E6E6"
                          width="100%"
                          height="48px"
                          sx={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "14.5px 26px",
                          }}
                        >
                          <Typography>Round off</Typography>
                          <Typography>
                            <Typography>
                              {formatAmount(state?.endofdaySummary?.round_off_total)}
                            </Typography>
                          </Typography>
                        </Stack>
                        <Stack
                          border={1}
                          borderColor="#E6E6E6"
                          width="100%"
                          height="48px"
                          sx={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "14.5px 26px",
                          }}
                        >
                          <Typography>Client Account</Typography>
                          <Typography>
                            {formatAmount(state?.endofdaySummary?.client_account_total)}
                          </Typography>
                        </Stack>
                      </Stack>
                      <Stack direction="row">
                        <Stack
                          border={1}
                          borderColor="#E6E6E6"
                          width="100%"
                          height="48px"
                          sx={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "14.5px 26px",
                          }}
                        >
                          <Typography>Variance</Typography>
                          <Typography
                            fontWeight={500}
                            color={
                              state?.endofdaySummary?.variance === 0
                                ? "#0F875B"
                                : "#C42B1C"
                            }
                          >
                            {formatAmount(state?.endofdaySummary?.variance)}
                          </Typography>
                        </Stack>
                        <Stack
                          border={1}
                          borderColor="#E6E6E6"
                          width="100%"
                          height="48px"
                          sx={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "14.5px 26px",
                          }}
                        >
                          <Typography>EFT/Card</Typography>
                          <Typography>
                            <Typography>
                              {formatAmount(state.endofdaySummary.card_total)}
                            </Typography>
                          </Typography>
                        </Stack>
                      </Stack>
                      <Stack direction="row">
                        <Stack
                          border={1}
                          borderColor="#E6E6E6"
                          width="100%"
                          height="48px"
                          sx={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "14.5px 26px",
                          }}
                        >
                          <Typography>Cheque</Typography>
                          <Typography>
                            {formatAmount(state.endofdaySummary.cheque_total)}
                          </Typography>
                        </Stack>
                        <Stack
                          border={1}
                          borderColor="#E6E6E6"
                          width="100%"
                          height="48px"
                          sx={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "14.5px 26px",
                          }}
                        >
                          <Typography>Stripe</Typography>
                          <Typography>
                            {formatAmount(
                              state?.endofdaySummary?.online_ordering_sales,
                            )}
                          </Typography>
                        </Stack>
                      </Stack>
                      <Stack direction="row">
                        <Stack
                          border={1}
                          borderColor="#E6E6E6"
                          width="100%"
                          height="48px"
                          sx={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "14.5px 26px",
                          }}
                        >
                          <Typography>Uber Eats</Typography>
                          <Typography>
                            {formatAmount(state.endofdaySummary?.ubereats_sales)}
                          </Typography>
                        </Stack>
                        <Stack
                          border={1}
                          borderColor="#E6E6E6"
                          width="100%"
                          height="48px"
                          sx={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "14.5px 26px",
                          }}
                        >
                          <Typography>DoorDash</Typography>
                          <Typography>
                            {formatAmount(state.endofdaySummary?.dd_sales)}
                          </Typography>
                        </Stack>
                      </Stack>
                      <Stack direction="row">
                        <Stack
                          border={1}
                          borderColor="#E6E6E6"
                          width="100%"
                          height="48px"
                          sx={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "14.5px 26px",
                          }}
                        ></Stack>
                        <Stack
                          border={1}
                          borderColor="#E6E6E6"
                          width="100%"
                          height="48px"
                          sx={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "14.5px 26px",
                          }}
                        >
                          <Typography color="#808080">Total Tax</Typography>
                          <Typography color="#808080">
                            {formatAmount(state?.endofdaySummary?.total_tax)}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Card>
                  )}
                </Box>
              </>
            </TabPanel>
            <TabPanel sx={{ px: "0" }} value="?history">
              <EndofDayHistory />
            </TabPanel>
          </TabContextProvider>
        </ContentLayout>
      )}
    </>
  );
};
